import { Middleware } from '@nuxt/types';
import { useStoryblokApi } from '@storyblok/nuxt-2';
import { Logger } from '~/helpers/logger';
import resolveSBLanguage from '~/modules/storyblok/helpers/resolveSBLanguage';

const urlResolverMiddleware : Middleware = async (context) => {
  const storyblokApi = useStoryblokApi();
  const { path } = context.route;
  const replacedPath = path.replace(/^\/(pl|en)\//, '');
  const language = resolveSBLanguage(context.app.i18n.locale);
  Logger.debug('middleware/story-url-resolver', replacedPath);

  try {
    const { data } = await storyblokApi.get(`cdn/stories/${replacedPath}`, {
      version: context.env.VSF_STORYBLOK_VERSION,
      language,
    });
    const results = (data as any)?.story ?? null;
    Logger.debug('middleware/story-url-resolver/result', { data });

    // eslint-disable-next-line no-param-reassign
    context.app.currentStory = results;
  } catch (error) {
    console.log('error', error);
    if (typeof error === 'string') {
      const parsedError = JSON.parse(error as string);
      context.error({ statusCode: parsedError.status ?? 500 });
    } else {
      context.error({ statusCode: 500 });
    }
  }
};

export default urlResolverMiddleware;
